import {Table, Text, type TextProps} from '@mantine/core'
import type {Workdays} from '@package/shared'
import {getLocalWeekdays} from '../../../calendar/formatter/getLocalWeekdays.ts'
import {useUserSettings} from '../../../../providers/userSettings/useUserSettings.ts'
import {Fragment} from 'react'
import dayjs from 'dayjs'
import {formatTime} from '../../../calendar/formatter/formatTime.ts'

type Props = {
  value: Workdays | undefined
} & Pick<TextProps, 'c' | 'size'>

export const WorkweekView = ({value: workdays, c, size}: Props) => {
  const {userSettings} = useUserSettings()
  if (!workdays || Object.values(workdays).filter((workday) => !!workday).length === 0) {
    return (
      <Text c={'dimmed'} size={size}>
        No workweek configured
      </Text>
    )
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: 5}}>
      <Table highlightOnHover={false} withRowBorders={false} verticalSpacing={5} horizontalSpacing={0}>
        <Table.Tbody>
          {getLocalWeekdays(userSettings).map(({weekday, weekdayIndex}) => {
            const workday = workdays[weekdayIndex] || []

            return (
              <Fragment key={weekdayIndex}>
                <Table.Tr>
                  <Table.Td width={120} style={{verticalAlign: 'top'}}>
                    <Text c={c} size={size}>
                      {weekday}
                    </Text>
                  </Table.Td>
                  <Table.Td>
                    <Text c={c} size={size}>
                      {workday.length === 0 && '-'}
                      {workday.map((timeRange) => {
                        if (!timeRange?.start || !timeRange.end) return null

                        const [startHour, startMinute] = timeRange.start.split(':').map(Number)
                        const [endHour, endMinute] = timeRange.end.split(':').map(Number)

                        const start = dayjs().set('hour', startHour).set('minute', startMinute).startOf('minute')
                        const end = dayjs().set('hour', endHour).set('minute', endMinute).startOf('minute')

                        return (
                          <Fragment key={timeRange.start}>
                            {formatTime(dayjs(start), userSettings)} - {formatTime(dayjs(end), userSettings)}
                            <br />
                          </Fragment>
                        )
                      })}
                    </Text>
                  </Table.Td>
                </Table.Tr>
              </Fragment>
            )
          })}
        </Table.Tbody>
      </Table>
    </div>
  )
}
